import React from "react";

import { TableBody, Box } from "@mui/material";
import StateWrapper from "./stateWrapper/StateWrapper";

import OrixiaSpinner from "../../../../components/OrixiaSpinner";

function TableBodyO({ cabeceras, visibleRows, listadoSeleccion, loading }) {
  return (
    <TableBody sx={{ width: "100%", position: "relative" }}>
      {visibleRows.map((d) => (
        <StateWrapper
          data={d}
          key={d._key}
          cabeceras={cabeceras}
          listadoSeleccion={listadoSeleccion}
        />
      ))}
      {loading && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background:
              "radial-gradient(circle, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0.5) 100%)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10,
          }}
        >
          <OrixiaSpinner text="Recuperando Datos ..." />
        </Box>
      )}
    </TableBody>
  );
}

export default React.memo(TableBodyO);
